module.exports = __webpack_public_path__ + "img/shape4.71f789f7.svg";